import { useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CircleIcon from "@mui/icons-material/Circle";

import classes from "./PointLayerLegend.module.css";

function PointLayerLegend(props) {
  const { id, layerName, color } = props;
  const layerProperties = useSelector(
    (state) => state.layers[id].properties
  );
  const layerType = useSelector((state) => state.layers[id].layerType);
  const colorValue = useSelector(
    (state) => state.layers[id].colorValue
  );
  const iconProperty = useSelector(
    (state) => state.layers[id].iconProperty
  );
  const iconMap = useSelector((state) => state.layers[id].iconMap);
  const dataName = useSelector((state) => state.layers[id].data);
  const dataState = useSelector((state) => state.data[dataName]);

  const colorByProperty = layerProperties.find((p) => p.id === colorValue);
  const colorMap = colorByProperty.colorMap;

  return (
    <Box sx={{ ml: 2, mr: 2, pt: 2, pb: 2 }}>
      <Typography
        sx={{
          color: color ? color : "inherit",
        }}
      >
        {layerName}
      </Typography>
      <Box sx={{ mb: 1 }}>
        <Typography
          sx={{
            display: "flex",
            fontSize: "0.7rem",
            color: color ? color : "inherit",
            textTransform: "uppercase",
          }}
        >
          {colorByProperty.label}
        </Typography>
        <Box>
          {Object.keys(colorMap)
            .sort((a, b) => a - b)
            .map((key) => {
              return (
                (key !== "No Data" || colorByProperty.showNoData) && (
                  <span key={key} className={classes["legend-value-container"]}>
                    <CircleIcon
                      sx={{ color: colorMap[key].hex, fontSize: "14px" }}
                    />

                    <Typography
                      sx={{
                        fontSize: "0.8rem",
                        color: color ? color : "inherit",
                      }}
                    >
                      {colorByProperty.checkForValueLabels &&
                      dataState.metadata &&
                      dataState.metadata["value_labels"] &&
                      dataState.metadata["value_labels"][colorValue]
                        ? dataState.metadata["value_labels"][colorValue][key]
                        : key}
                    </Typography>
                  </span>
                )
              );
            })}
        </Box>
      </Box>
      {layerType === "icon" && (
        <>
          {typeof iconProperty === "string" ||
          iconProperty instanceof String ? (
            <Box sx={{ mt: 1, mb: 1 }}>
              <Typography
                sx={{
                  display: "flex",
                  fontSize: "0.7rem",
                  color: color ? color : "inherit",
                  textTransform: "uppercase",
                }}
              >
                Site Type
              </Typography>
              <Box>
                {Object.keys(iconMap).map((key) => {
                  return (
                    <span
                      key={key}
                      className={classes["legend-value-container"]}
                    >
                      <img
                        className={classes["legend-icon"]}
                        src={iconMap[key].url}
                        alt={iconMap[key].name}
                      />
                      <Typography
                        sx={{
                          fontSize: "0.8rem",
                          color: color ? color : "inherit",
                        }}
                      >
                        {key}
                      </Typography>
                    </span>
                  );
                })}
              </Box>
            </Box>
          ) : (
            <p className={classes["legend-section-title"]}>
              <u>Shape: </u>
              <span className={classes["legend-value-container"]}>
                <img
                  className={classes["legend-icon"]}
                  src={iconProperty.url}
                  alt={iconProperty.name}
                  style={{
                    width: iconProperty.legendX ? iconProperty.legendX : "10px",
                    height: iconProperty.legendY
                      ? iconProperty.legendY
                      : "10px",
                  }}
                />
              </span>
            </p>
          )}
        </>
      )}
    </Box>
  );
}

export default PointLayerLegend;
